import type { ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';

export function BannerH2({
  children,
  className = '',
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <h2
      className={twJoin([
        'mb-4 ml-0 block border-0 w-fit bg-black dark:bg-grey-dark py-2 pl-2.5 pr-5 font-secondary text-4xl font-normal uppercase text-white xl:inline-block xl:w-fit rounded-r-2xl',
        className ?? '',
      ])}
    >
      {children}
    </h2>
  );
}
